function Sweden({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2249)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M12.5219 13.9131H31.8647C30.842 6.06262 24.1293 0 16.0001 0C14.8055 0 13.6418 0.132063 12.5219 0.380313V13.9131H12.5219Z" fill="#0052B4"/>
  <path d="M8.34787 13.9129V1.94531C3.95449 4.34244 0.809435 8.73938 0.135498 13.9129H8.34787V13.9129Z" fill="#0052B4"/>
  <path d="M8.3478 18.0869H0.135498C0.809435 23.2605 3.95449 27.6574 8.34787 30.0545L8.3478 18.0869Z" fill="#0052B4"/>
  <path d="M12.5219 18.087V31.6197C13.6418 31.8679 14.8055 32 16.0001 32C24.1293 32 30.842 25.9374 31.8647 18.0869H12.5219V18.087Z" fill="#0052B4"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Sweden;
